// extracted by mini-css-extract-plugin
module.exports = {"star":"SelectInput_star__3dBUt","active":"SelectInput_active__2yxWy","labelActive":"SelectInput_labelActive__2iLbH"};